module.exports = __webpack_public_path__ + "img/fi-rr-world.06c0c9d8.svg";